import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { DataObjectDeleteDocument, DataObjectType } from '@/gql/graphql';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { formatFileName } from '@/utils/file-utils';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'DataObjectDelete',
  props: {
    show: { type: Boolean },
    dataObject: {},
    bucketId: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});

const objectType = computed<string>(() => {
  if (props.dataObject) {
    return props.dataObject.isFolder ? 'Folder' : 'File';
  }
  return '';
});

// --- Mutation: Rename Data Object ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(DataObjectDeleteDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.dataObjectDelete) {
    console.debug('Data object deleted:', res.data.dataObjectDelete);
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Deletion failed: ' + res.data;
    console.error('Data object deletion failed:', res.data);
  }
});
onMutationError((err) => {
  console.error('Error deleting data object:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onDeletionConfirmed() {
  if (!props.dataObject) {
    mutationError.value = 'Data object not provided for deletion';
    console.error('Data object not provided for deletion');
    return;
  }
  if (typeof props.dataObject.name !== 'string') {
    mutationError.value = 'Data object name is not a string';
    console.error('Data object name is not a string:', props.dataObject.name);
    return;
  }
  if (typeof props.dataObject.isFolder !== 'boolean') {
    mutationError.value = 'Data object `isFolder` field type is not a boolean';
    console.error(
      'Data object `isFolder` field type is not a boolean:',
      props.dataObject.isFolder
    );
    return;
  }

  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({
    bucketId: props.bucketId,
    objectName: props.dataObject.name,
    isFolder: props.dataObject.isFolder,
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "trash",
          class: "me-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Delete ", -1)),
        _createElementVNode("strong", null, _toDisplayString(_unref(formatFileName)(__props.dataObject?.name)), 1),
        _createTextVNode(" " + _toDisplayString(objectType.value.toLowerCase()), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "danger",
          disabled: mutationInProgress.value || mutationShowSuccess.value,
          onClick: onDeletionConfirmed
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createTextVNode(" Deleting " + _toDisplayString(objectType.value) + " ", 1),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(objectType.value) + " Deleted ", 1),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, " Delete " + _toDisplayString(objectType.value), 1))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        (__props.dataObject)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, [
                _createTextVNode(" Are you sure you want to delete the " + _toDisplayString(objectType.value.toLowerCase()) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_unref(formatFileName)(__props.dataObject.name)), 1),
                _cache[4] || (_cache[4] = _createTextVNode("? ", -1))
              ]),
              _createVNode(_unref(BAlert), {
                modelValue: mutationError.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mutationError).value = $event)),
                variant: "danger",
                dismissible: "",
                class: "mt-3",
                onDismissed: _cache[1] || (_cache[1] = ($event: any) => (mutationError.value = null))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(mutationError.value), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})